import React, { FC } from 'react';
import { connect } from 'react-redux';

import { ReduxState } from 'app/redux/types';

import { BET_ERROR_DICTIONARY, BetErrorCode, TypeOfError } from '../../../constants';
import { RecordOfEntryErrorType } from '../../../records';
import { selectBets, selectRequestErrorShowing, selectStakes } from '../../../selectors/entries';
import { selectSingleBetsInfo } from '../../../selectors/stakeTypes/single';
import Error from '../../EntryComponents/Error';
import EntryHeader from '../../EntryComponents/Header';
import Name from '../../EntryComponents/Name';

import entryStyles from '../../EntryComponents/EntryComponents.module.scss';
import styles from './ExpressInsideMatch.module.scss';

// ---

type StoreProps = {
  stakeName?: string;
  isOpen: boolean;
  error: RecordOfEntryErrorType | null;
  showRequestError: boolean;
};

type EntryProps = {
  betId: number;
};

const Entry: FC<EntryProps & StoreProps> = ({
  betId,
  isOpen,
  stakeName,
  error,
  showRequestError,
}) => {
  const isBetError = error?.type === TypeOfError.BET;

  return (
    <div className={styles.expressInsideMatch}
         data-test="expressInsideMatchEntry-container">
      <EntryHeader betId={betId} />
      <Name value={stakeName}
            error={showRequestError || !isOpen}
            className={entryStyles.stakeName} />

      {((showRequestError && isBetError) || !isOpen) && (
        <Error message={isOpen ? '' : BET_ERROR_DICTIONARY[BetErrorCode.RECEPTION_CLOSED]}
               error={isOpen ? error : null}
               className={styles.entryErrorMessage} />
      )}
    </div>
  );
};

const mapStateToProps = (state: ReduxState, { betId }: EntryProps): StoreProps => {
  const bet = selectBets(state).get(betId);
  const stake = bet && selectStakes(state).get(bet.entity.stakeId);

  const betInfo = selectSingleBetsInfo(state).get(betId);
  const error = betInfo?.get('error') || null;

  const isOpenBet = bet?.entity.isOpen ?? false;
  const isOpenStake = bet?.entity.isOpen ?? false;

  return ({
    isOpen: isOpenBet || isOpenStake,
    stakeName: stake?.entity.names.get('long'),
    error,
    showRequestError: selectRequestErrorShowing(state, betId),
  });
};

export default connect(mapStateToProps)(Entry);
